<template>
    <div class="bg-white rounded shadow  container-box">

      <div class="row mt-2 top-button form-group-button">
        <div class="col-md-12" v-if="client">
          <router-link class="btn btn-light btn-sm back"
                       :to="{ name: 'client-edit', params: { clientId: clientId}}">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
          </router-link>
        </div>
      </div>

        <div class="row">
            <div class="col-md-12">
                <router-view :clientId="clientId" :client="client"/>
            </div>
        </div>
    </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex';
  import axios from 'axios';

export default {
  name: 'DashboardQuiz',
  props: {
    'clientId': {
      type: [Number, String],
      default() {
        return null;
      },
    },
  },
  computed: {
    ...mapGetters('auth', [
      'isTherapist'
    ]),
    ...mapState([
      'route',
    ]),
  },
  data() {
    return {
      apiUrl: '/quiz/',
      apiClientUrl: '/users/clients/',
      client: null,
    }
  },

  created() {
    if(!this.client){
      this.getClient(this.clientId);
    }
  },

  methods:{

    getClient: async function(clientId) {
      try {
        let response = await axios.get(this.apiClientUrl + clientId);
        this.client = response.data.data;
      } catch (error) {
        console.dir(error);
      }
    },

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/quiz/components/QuizDashboardLayout.vue